// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretDown(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretDown" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 9.5H17L12 14.5L7 9.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretDown.js.map